import {Pipe, PipeTransform} from '@angular/core';
import {LabelDto} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/label-dto';

export class LabelPipeParam {
    maxLength: number;
}
@Pipe({
    name: 'Label',
    standalone: true
})
export class LabelPipe implements PipeTransform {
    transform(value: LabelDto | string | null | undefined, param?: LabelPipeParam): string {
        // Handle case where backend returns string (via @LabelToString)
        if (typeof value === 'string') {
            return value;
        }
        const val = value ? value.fr : '';
        if (val && param && param.maxLength && val.length > param.maxLength) {
            return val.substring(0, param.maxLength) + '...';
        }
        return val || '';
    }
}
